export default __webpack_public_path__ + "static/media/privacypolicy.58f73c72.jpg";